import React from "react";
import TagCard from "./TagCard";
import styled from "styled-components";
import EditButton from "../buttons/EditButton";
import DeleteButton from "../buttons/DeleteButton";
import {DisplayForHead} from "../../permissions/DisplayAccordingToRole";

const ToggleTagCard = ({
                           setCategoryId,
                           id,
                           color,
                           name,
                           updateTagCategory,
                           setDeleteCategoryModalIsOpen,
                           categoryId
                       }) => {


    const displayTags = (id) => {
        setCategoryId(id)
    }

    return (
        <Card>
            <DisplayForHead component={
                <ButtonsContainer onClick={async () => await setCategoryId(id)}>
                    <EditButton
                        data={id}
                        setUpdate={updateTagCategory}
                    />
                    <DeleteButton
                        setOpenDeleteModal={setDeleteCategoryModalIsOpen}
                    />
                </ButtonsContainer>}
            />
            <TagCard
                id={id}
                color={color}
                name={name}
                displayTags={displayTags}
                categoryId={categoryId}
            />
        </Card>
    )
}
const Card = styled.div`
  display: flex;
  flex-direction: column;
`

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`

export default ToggleTagCard;